import React from 'react';
import Translate from 'react-translate-component';
import { any, compose, props } from 'ramda';

import { notEmpty } from 'utils/ramdaAdditions';
import { education, experience, language, sex } from 'constants/dictionaries';
import { intervalTemplate } from 'helpers/fieldsHelpers';
import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';
import { DefinitionField } from 'components/common/fields/DefinitionField';
import LoadField from 'components/common/fields/LoadField';
import RequestLanguages from './RequestLanguages';
import RequestEducation from './RequestEducation';

const getFieldAge = (age = {}) => (age.from || age.to) && (
    <span>
        { intervalTemplate(age.from, age.to) }
        { " " }
        { <Translate content="request.age.value" /> }
    </span>
);

const notEmptyAge = age => age.from || age.to;
const notEmptyEducation = education => education && Boolean(education.level);

const hasFields = compose(any(Boolean), props(['sex', 'requirement', 'responsibilities', 'experience']));
const hasRequirements = request => hasFields(request)
    || notEmptyAge(request.age)
    || notEmptyEducation(request.education)
    || notEmpty(request.languages);

export const RequestRequirementsForCandidate = ({ request }) => hasRequirements(request) ? (
    <div>
        <DefinitionHeader translate="project.requirements_for_candidate" iconType="list-ul" />
        <div className="panel-view">
            <DefinitionField translate="request.requirements" text={ request.requirement } />
            <DefinitionField translate="request.responsibilities" text={ request.responsibilities } />
            <DefinitionField translate="request.education" show={notEmptyEducation(request.education)}>
                <LoadField loadName={education} component={RequestEducation} education={request.education} />
            </DefinitionField>
            <DefinitionField translate="common.languages" show={notEmpty(request.languages)}>
                <LoadField loadName={language} component={RequestLanguages} languages={request.languages} />
            </DefinitionField>
            <DefinitionField translate="common.sex" show={request.sex}>
                <LoadField loadName={sex} fieldId={request.sex} />
            </DefinitionField>
            <DefinitionField translate="request.age.title" show={notEmptyAge(request.age)}>
                { getFieldAge(request.age) }
            </DefinitionField>
            <DefinitionField translate="request.experience" show={request.experience}>
                <LoadField loadName={experience} fieldId={ request.experience } />
            </DefinitionField>
        </div>
    </div>
) : null;
